module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4M0Hfzivg69DBuDhgYJIym-44921d99460065c0ee41eb683e9c2b4f.jpg";